import { selectPaymentSum } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/selectors/selectPaymentSum';
import { TAppThunkDispatch, TGetState } from '~/src/store';

import payByBindedCard from './payByBindedCard';
import payByNewCard from './payByNewCard';
import payBySbp from './payBySbp';

const paySeasonTicket = () => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState): Promise<void> => {
        const state = getState();

        const {
            payment: { method, isSaveCard },
        } = state;

        const currentPaySum = selectPaymentSum(state);
        const methodType = method?.methodType;

        if (currentPaySum || (methodType === 'new-card' && isSaveCard)) {
            switch (methodType) {
                case 'card':
                    dispatch(payByBindedCard(currentPaySum));
                    break;
                case 'new-card':
                    dispatch(payByNewCard(currentPaySum));
                    break;
                case 'sbp':
                    dispatch(payBySbp(currentPaySum));
                    break;
            }
        }
    };
};

export default paySeasonTicket;
